import { services } from "../../../../constants";
import { cache } from "../../../persistence/cache";
import { phoneVerificationData } from "../../../store";
import { canUpdateToken, updateUserData } from "../tokenOperations";
import errors from "../../../errors";
import { setCookie } from "../../../../utils/cookiesUtils";

/**
 * Retrieves the signup service necessary configuration to make the final request to the
 * middleware. This is the step that decides, depending on the data coming, if the signup
 * will be made to the v1 or the v2 of the signup MW endpoint.
 * @param {Object} config - Data coming to be sent in signup request.
 * @returns {Object} Object containing signup service configuration to make the final request.
 * @private
 */
async function getSignupServiceConfig(config) {
  console.log('checking config console', config)
  const { smsCode, otp, paymentMethod, paymentPlanId, isOperatorActivated = false, ...restConfig } = config;
  const requestBody = restConfig;
  let signupEndpoint = config.signupWithSSO ? services.ssoSignupV2 : services.signupV2;
  let requestHeaders = null;

  if (!!otp) {
    const phoneVerificationCode = await phoneVerificationData.get.call(this);
    let extraParamsQuery = this.parseQueryString({ paymentMethod, paymentPlanId });
    if (otp && paymentMethod !== undefined && paymentPlanId !== undefined) {
      extraParamsQuery = `paymentMethod=${paymentMethod}&paymentPlanId=${paymentPlanId}&isOperatorActivated=${!isOperatorActivated}`;
      requestHeaders = { headers: { phoneVerificationCode } };
    }
    if (phoneVerificationCode !== null) {
      signupEndpoint = `${services.signupV1}?otp=${otp}${!!extraParamsQuery ? `&${extraParamsQuery}` : ""}`;
      requestHeaders = { headers: { phoneVerificationCode } };
    } else {
      throw Error(errors.authentication.signup.MISSING_MANDATORY_PHONE_VERIFICATION_CODE);
    }
  }

  return { signupEndpoint, requestBody, requestHeaders };
}

const signup = {
  async run(config) {
    try {
      const { signupEndpoint, requestBody, requestHeaders } = await getSignupServiceConfig.call(this, config);
      const response = await this.http.post(
        `${this.backendHosts.auth}${signupEndpoint}`,
        {
          ...requestBody,
          language: this.lang
        },
        requestHeaders
      );
      const spxToken = response && response.data && response.data.spx;
      const jwtCookie = this.jwtCookie;
      setCookie("spx-token", spxToken, jwtCookie.expirationTime);
      setCookie("UID", Date.now());
      if (!!config.autologin && canUpdateToken(response)) {
        updateUserData.call(this, response.data.token, response.data.globalUserId, config);
        // FIXME This line is not about login, it's about cache, it should not be here
        cache.clear({ database: "layouts" });
        return response.data.user;
      }
      return response.data;
    } catch (error) {
      this.handleErrorResponse(error);
    }
  }
};

export default signup;
